import { HTMLProps, ReactNode, forwardRef } from 'react'

import { FieldError } from 'react-hook-form'

import clsx from 'clsx'

import { IPhoneCountry } from '../phone-input/phone-input'

import styles from './styles.module.scss'

interface Props extends HTMLProps<HTMLInputElement> {
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  error?: FieldError | boolean
  isPhoneInput?: boolean
  currentPhoneCountry?: IPhoneCountry
  onShowBottomSheet?: () => void
  showBorder?: boolean
  isGray?: boolean
  isSecondary?: boolean
}

export const Input = forwardRef<HTMLInputElement, Props>(
  (
    {
      leftIcon,
      rightIcon,
      currentPhoneCountry,
      isPhoneInput,
      onShowBottomSheet,
      error,
      value,
      autoComplete = 'off',
      showBorder = true,
      isGray,
      isSecondary,
      ...props
    },
    ref,
  ) => {
    return (
      <div>
        <div
          className={clsx(
            !leftIcon && !rightIcon && styles.container,
            leftIcon && styles.leftContainer,
            rightIcon && styles.rightContainer,
            leftIcon && rightIcon && styles.bothContainer,
            error && styles.errorContainer,
            isPhoneInput && styles.phoneInput,
            showBorder && styles.containerWithIcon,
            isGray && styles.grayContainer,
            isSecondary && styles.secondaryContainer,
          )}
        >
          {leftIcon ? (
            <div className={styles.leftIcon}> {leftIcon} </div>
          ) : null}

          {isPhoneInput && onShowBottomSheet && (
            <div
              className={styles.countryCodeField}
              onClick={() => onShowBottomSheet()}
            >
              <img
                alt=""
                src={currentPhoneCountry?.flag}
                className={styles.countryIcon}
              />

              <p className={styles.countryCode}>
                {currentPhoneCountry?.dial_code}
              </p>
            </div>
          )}

          <input
            ref={ref}
            value={value}
            autoComplete={autoComplete}
            {...props}
            className={clsx(
              isGray && styles.grayInput,
              isSecondary && styles.secondaryInput,
            )}
          />

          {rightIcon ? (
            <div className={styles.rightIcon}> {rightIcon} </div>
          ) : null}
        </div>

        {/* TODO */}
        {typeof error !== 'boolean' && error?.message && (
          <p className={clsx(styles.errorText, 'medium-12')}>
            {error?.message}
          </p>
        )}
      </div>
    )
  },
)

Input.displayName = 'Input'
